import {i18n} from '@zui/core';

i18n.addLang({
    'zh_cn': {
        today: '今天',
        yearFormat: '{0}年',
        weekNames: ['日', '一', '二', '三', '四', '五', '六'],
        monthNames: ['1月', '2月', '3月', '4月', '5月', '6月', '7月', '8月', '9月', '10月', '11月', '12月'],
    },
    'zh_tw': {
        today: '今天',
        yearFormat: '{0}年',
        weekNames: ['日', '一', '二', '三', '四', '五', '六'],
        monthNames: ['1月', '2月', '3月', '4月', '5月', '6月', '7月', '8月', '9月', '10月', '11月', '12月'],
    },
    en: {
        today: 'Today',
        yearFormat: '{0}',
        weekNames: ['SUN', 'MON', 'TUE', 'WED', 'THU', 'FRI', 'SAT'],
        monthNames: ['Jan.', 'Feb.', 'Mar.', 'Apr.', 'May.', 'Jun.', 'Jul.', 'Aug.', 'Sept.', 'Oct.', 'Nov.', 'Dec.'],
    },
});
